import {SummaryModel} from "../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";

export class AgendaCategorySummaryModel implements SummaryModel{

   id: number;
   permissions: PermissionsModel;
   name: string;
   color: string;
   textColor: string;
}
